export const types = {
  SET_EDITABLE_SINGLE_SIGN_ON_CONFIGURATION: 'SET_EDITABLE_SINGLE_SIGN_ON_CONFIGURATION',
  RESET_SINGLE_SIGN_ON_CONFIGURATION: 'RESET_SINGLE_SIGN_ON_CONFIGURATION',
  SET_VALIDATION_SINGLE_SIGN_ON_CONFIGURATION: 'SET_VALIDATION_SINGLE_SIGN_ON_CONFIGURATION',
  UPDATE_SINGLE_SIGN_ON_CONFIGURATION: 'UPDATE_SINGLE_SIGN_ON_CONFIGURATION',
};
